import { LOCALES } from "../locales";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  [LOCALES.ENGLISH]: {
    //COMMON
    commonBackToTheMainPage: "Back to the main page",
    commonBackToOrganizersPage: "Back to organizers list",
    hideRows: "First 10 rows were hidden",

    //HEADER
    headerDevicesConnected: "Connected to panel",
    headerOptToUsers: "Set user otp",
    headerOpenProfiles: "Open profiles",
    headerOpenOrganizers: "Open organizers",
    headerOpenOrganizersRequest: "Open organizer requests",
    headerOpenDocuments: "Open documents",
    headerOpenTransactions: "Open Transactions",
    headerTotalMoney: "Total money",
    headerTotalFee: "Total fee",
    headerTransactionTotalFee: "Transaction Fee",
    headerTransactionTotalFastFee: "Fast Transaction Fee",
    headerTransactionTotalEarlyFee: "Early Transaction Fee",
    headerDownloadReport: "Report",
    headerCancelTicket: "Cancel Ticket",

    // SEND OTP MODAL
    otpCode: "User otp code",
    setOtp: "Set otp",
    otpSetSuccess:
      "Otp code mocked for user for next 60 minutes and code copied to your clipboard",
    otpSetFailed: "Otp code failed",

    //DEVICES MODAL
    devicesModalTitle: "Active Devices",
    otpModalTitle: "Set user otp",
    robotCreditsModalTitle: "Change user robot sms credits",
    devicesModalActionDisconnectSuccess: "Device disconnect success",
    devicesModalActionDisconnectFailure: "Device disconnect error",

    //ADD PAYMENT MODAL
    apModalTitle: "Add new payment",
    apModalDropFileHere: "Drop file here",
    apModalDragFileHere: "Drag file here",
    apModalUploadFile: "UPLOAD FILE",
    apModalReUploadFile: "REUPLOAD FILE",

    //FILTER
    filterTitle: "FILTER",
    filterItemOnlyPaid: "Only paid",
    filterItemSortByName: "Sort by name",
    filterItemAscending: "Ascending",
    filterSubmit: "SUBMIT",
    filterRestore: "RESTORE",
    filterSearch: "SEARCH",

    //CUSTOM DATE RANGE PICKER
    cdrpFrom: "From...",
    cdrpTo: "To...",

    //CUSTOM DATAGRID
    customDataGridLoadMore: "LOAD MORE",

    // EVENTS STATUS NAV
    esnWaitingForConfirm: "Waiting for confirm",
    esnDeletedEvents: "Deleted",
    esnFinishedEvents: "Finished",
    esnFinishedUnpaidEvents: "Unpaid",
    esnHiddenEvents: "Hidden",
    esnAllEvents: "All",
    esnActiveEvents: "Active",
    esnCanceledEvents: "Canceled",
    esnInProgressEvents: "In Progress",
    esnCurrentWeekEvents: "Current week",

    //PROFILES
    gridProfilesTotalClearances: "Total clearances",
    gridProfilesTotalPurchases: "Total purchases",
    gridProfilesAmountOfPurchasedTickets: "Amount of tickets purchased",
    gridProfilesAmountOfEvents: "Amount of events",
    gridProfilesProducerAndIdentityCardOrHPAndPhoneNumber:
      "Producer information",
    gridProfilesCreatorOfTheEvent: "Creator of the event",
    gridProfilesPostalCode: "Postal code",
    gridProfilesCellphoneNumber: "Cellphone number",
    gridProfilesLinkToProfile: "Link to profile",
    gridProfilesDeletedUser: "Deleted user",
    gridProfilesChangeRobotSmsCredits: "Change Robot SMS Credits",
    gridProfilesChangeRobotSmsCreditsCount: "Robot SMS Credits:",
    gridProfilesChangeRobotSmsAccess: "Robot SMS",
    gridProfilesRestoreUser: "Restore user",
    gridProfilesAutoConfirmationUser: "Auto Confirmation",

    buttonDownloadAllInformation: "Download all information",
    profilesDeletedProfiles: "Deleted profiles",
    profilesAllProfiles: "All profiles",
    profilesTotalCreditsCountL: "Robot Sms Total Credits:",

    //ALL EVENTS
    gridEventsOpenAsOwner: "Open as owner",
    gridEventsPaymentStatus: "Payment Status",
    gridEventsPaymentStatusIsPaidCheckBox: "Paid",
    gridEventsOrderConfirmation: "Order Confirmation",
    gridEventsFile: "File",
    gridEventsReceiptFile: "Receipt file",
    gridEventsInvoiceFile: "Invoice file",
    gridEventsBankAccountInfo: "Bank account info",
    gridEventsBankAccountInfoNumber: "Branch number",
    gridEventsBankAccountInfoAccountNumber: "Account number",
    gridEventsBankAccountFullName: "Full name",
    gridEventsTotalCommisionProfit: "Total commission profit",
    gridEventsTotalTicketsPurchasedInCredit: "Total money without fee",
    gridEventsTotalTicketsSold: "Total tickets sold",
    gridEventsTotalTicketsSoldInCredit: "Total tickets sold in credit",
    gridEventsCanceledMoney: "Canceled money",
    gridEventsCanceledCount: "Canceled count",
    gridEventsReturnedMoney: "Returned money",
    gridEventsReturnedCount: "Returned count",
    gridEventsProducerAndIdentityCardOrHPAndPhoneNumber: "Producer info",
    gridEventsCreatorName: "Full name",
    gridEventsCreatorAddress: "Address",
    gridEventsCreatorPhone: "Phone number",
    gridEventsStartDate: "Date of start",
    gridEventsCreateDate: "Date of creation",
    gridEventsName: "Event name",
    gridEventsStatus: "Event status",
    gridEventsStatusDeleted: "DELETED",
    gridEventsStatusHidden: "HIDDEN",
    gridEventsStatusHighPriority: "HIGH PRIORITY",
    gridEventsRepeatEvent: "REPEAT EVENT",
    gridEventsShowEvent: "SHOW EVENT",
    gridEventsConfirmEvent: "CONFIRM EVENT",
    gridEventsDeleteEvent: "DELETE EVENT",

    //TRANSACTIONS
    invoiceTotalInvoicesBeforeVAT: "Total invoices before VAT",
    invoiceTotalVAT: "Total VAT",
    invoiceTotalInvoicesIncluded: "Total invoices included",
    invoiceThisEventHasNoSuchFiles: "This event has no such files",
    transactionsInvoices: "Invoices",
    transactionsConfirm: "Confirms",
    transactionsCancelled: "Canceled",
    transactionsFetchError: "An error occurred while loading the page",

    //LOGIN
    loginEnterNumber: "ENTER YOUR PHONE NUMBER HERE",
    loginSendCode: "SEND CODE VIA SMS",
    loginEnterCode: "ENTER YOUR OTP CODE HERE",
    loginVerifyCode: "VERIFY OTP CODE",
    loginCodeSendSuccess: "OTP sended successfully!",
    loginCodeInvalid: "Invalid code!",
    loginError: "ERROR!",

    organizersAllOrganizers: "All",
    organizersActiveOrganizers: "Active",
    organizersNotActiveOrganizers: "Not Active",

    organizersTotalCount: "Total Organizers count:",
    organizersButtonDownloadExcel: "Download Excel",
    organizersButtonDownloadShortExcel: "Download short info",

    gridOrganizersOrganizerInfo: "Organizer Info",
    gridOrganizersName: "Full name:",
    gridOrganizersPhone: "Phone:",
    gridOrganizersEmail: "Email:",
    gridOrganizersIDcode: "ID Code:",

    gridOrganizersOrganizerEventsInfo: "Events Info",
    gridOrganizersTotalEventsCount: "Total Events:",
    gridOrganizersActiveEventsCount: "Active Events:",
    gridOrganizersFinishedEventsCount: "Finished Events:",
    gridOrganizersCancelledEventsCount: "Cancelled Events:",
    gridOrganizersPendingEventsCount: "Pending Events:",

    gridOrganizersOrganizerEventsActivityInfo: "Events Activity Info",
    gridOrganizersTotalTicketsSoldCount: "Total Tickets Count:",
    gridOrganizersTotalTicketsSoldMoney: "Total Tickets Money:",
    gridOrganizersTotalTicketsSoldFee: "Total Tickets Fee:",
    gridOrganizersActivePeriodTotalTicketsSoldCount: "Last 60d Tickets Count:",
    gridOrganizersActivePeriodTotalTicketsSoldMoney: "Last 60d Tickets Money:",
    gridOrganizersActivePeriodTotalTicketsSoldFee: "Last 60d Tickets Fee:",

    gridOrganizersOrganizerActivityInfo: "Activity Info",
    gridOrganizersJoinDate: "Join Date:",
    gridOrganizersLastEventDate: "Last Event Date:",
    gridOrganizersStatus: "Status:",
    gridOrganizersStatusActive: "Active 😊",
    gridOrganizersStatusNotActive: "Not Active 🤔",

    gridOrganizersSettings: "Settings",
    gridOrganizersChangeRobotSmsCreditsCount: "Robot SMS Credits:",
    gridOrganizersChangeRobotSmsCredits: "Change Robot SMS Credits",
    gridOrganizersChangeRobotSmsAccess: "Robot SMS",
    gridOrganizersAutoConfirmationUser: "Auto Confirmation",

    // Other
    changeUserCredits: "Update user robot sms credits",
    updateCreditsError: "Error. Try again please.",

    downloadReportModalTitle: "Download events report",
    ignoreYeshInvoiceText: "Ignore YeshInvoice",
    ignoreTransactionsText: "Ignore Transactions",
    ignoreZCreditText: "Ignore ZCredit",
    downloadReportFromDate: "From Date",
    downloadReportToDate: "To Date",
    downloadReport: "Download report",
    downloadReportError: "Error when trying download report",

    cancelTicketModalTitle: "Cancel ticket",
    phoneNumberPlaceholder: "Phone number",
    eventLinkPlaceholder: "Event Link",
    searchTickets: "Search Tickets",
    backToSearch: "Back to search",
    buyerUser: "Buyer User",
    ticketUser: "Ticket User",
    ticketInfo: "Ticket Info",
    price: "Price",
    feePrice: "Fee",
    cardHolder: "Card Holder",
    cardNumber: "Card Number",
    ticketStatus: "Change ticket status",
    returnMoney: "Return money (ZCredit)",
    sendSms: "Send sms",
    yeshInvoiceDocs: "Generate YeshInvoice documents",
    fullReturn: "Full return money (with fee)",
    changeTicketStatus: "Change tickets",
    backToList: "Back to list",
    ticketChangedSuccess: "Tickets status success changed",

    organizerSettingsAdminNote: "Admin note about organizer",
    organizerSettingsModalTitle: "Update organizer settings",
    organizerFreeTransactionCount: "Free Transaction Count",
    organizerTransactionFee: "Transaction Fee",
    organizerFastWithdrawalFee: "Fast Withdrawal Fee",
    organizerTransactionMinSum: "Transaction Min Sum",
    organizerEarlyWithdrawalEnabled: "Early Withdrawal",
    organizerEarlyWithdrawalPercent: "Early Withdrawal Percent",
    organizerEarlyWithdrawalDays: "Early Withdrawal Days",
    organizerEarlyWithdrawalFee: "Early Withdrawal Fee",
    organizerWithdrawalTypeDefault: "Default",
    organizerWithdrawalTypeDays: "By Days",
    organizerWithdrawalDays: "Withdrawal Days",
    organizerUpdateSettings: "Update Settings",
    organizerFreeTransactionCountMinError: "Free transaction minimum count 0",
    organizerFreeTransactionCountRequiredError:
      "Free transaction count is required",
    organizerTransactionFeeMinError: "Transaction fee minimum is 0",
    organizerTransactionFeeRequiredError: "Free transaction fee is required",
    organizerFastWithdrawalFeeMinError: "Fast withdrawal fee minimum is 0",
    organizerFastWithdrawalFeeRequiredError: "Fast withdrawal fee is required",
    organizerTransactionMinSumMinError: "Transaction minimum sum is 0",
    organizerTransactionMinSumRequiredError:
      "Free transaction minimum sum is required",
    organizerEarlyWithdrawalPercentMinError: "Transaction minimum percent is 0",
    organizerEarlyWithdrawalPercentMaxError:
      "Transaction maximum percent is 100",
    organizerEarlyWithdrawalPercentRequiredError:
      "Early withdrawal percent is required",
    organizerEarlyWithdrawalDaysMinError: "Early withdrawal days minimum -365",
    organizerEarlyWithdrawalDaysMaxError: "Early withdrawal days maximum 365",
    organizerEarlyWithdrawalDaysRequiredError:
      "Early withdrawal days is required",
    organizerEarlyWithdrawalFeeMinError:
      "Early withdrawal fee minimum percent is 0",
    organizerEarlyWithdrawalFeeMaxError:
      "Early withdrawal fee maximum percent is 100",
    organizerEarlyWithdrawalFeeRequiredError:
      "Early withdrawal fee is required",
    organizerWithdrawalDaysMinError: "Withdrawal days minimum is 0",
    organizerWithdrawalDaysRequiredError: "Withdrawal days is required",

    transactionAll: "All",
    transactionPending: "Pending",
    transactionWithdrawn: "Withdrawn",
    transactionRejected: "Rejected",
    transactionCancelled: "Cancelled",
    transactionInProgress: "In Progress",
    transactionFast: "Fast",

    showTransactions: "Show Transactions",

    gridEventTransactionListTransactionNameInfo: "Common Info",
    gridEventTransactionListTransactionName: "Transaction Name",
    gridEventTransactionListTransactionDescription: "Transaction Note",
    gridEventTransactionListTransactionAdminDescription:
      "Transaction Admin Note",

    gridEventTransactionListEventInfo: "Event Info",
    gridEventTransactionListEventName: "Event Name",
    gridEventTransactionListEventStartDate: "Event Start Date",
    gridEventTransactionListEventEndDate: "Event End Date",
    gridEventTransactionListEventShowInfo: "Show Info",

    gridEventTransactionListOrganizerInfo: "Organizer Info",
    gridEventTransactionListOrganizerName: "Full Name",
    gridEventTransactionListOrganizerPhone: "Phone",
    gridEventTransactionListShowOrganizerInfo: "Show Info",

    gridEventTransactionListTransactionInfo: "Transaction Info",
    gridEventTransactionListItemLastTransaction: "Last Event Transaction",
    gridEventTransactionListItemFastWithdrawal: "Fast Withdrawal",
    gridEventTransactionListItemEarlyWithdrawal: "Early Withdrawal",
    gridEventTransactionListItemTotal: "Total Amount",
    gridEventTransactionListItemAmount: "Withdrawal Amount",
    gridEventTransactionListItemFee: "Transaction Fee",
    gridEventTransactionListItemEarlyFee: "Early Withdrawal Fee",
    gridEventTransactionListItemFastFee: "Fast Withdrawal Fee",

    gridEventTransactionListBillAccountInfo: "Bank Account Info",
    gridEventTransactionListBillAccountName: "Name",
    gridEventTransactionListBillAccountDescription: "Description",
    gridEventTransactionListBillAccountHolderName: "Holder Full Name",
    gridEventTransactionListBillAccountBankName: "Bank Name",
    gridEventTransactionListBillAccountBankNumber: "Bank Number",
    gridEventTransactionListBillAccountBankAccountNumber: "Bank Account Number",
    gridEventTransactionListBillAccountIdCode: "ID Code",

    gridEventTransactionListTransactionDates: "Transaction Dates",
    gridEventTransactionListRequestDate: "Request Date",
    gridEventTransactionListLastChangeDate: "Last Change Date",
    gridEventTransactionListStatus: "Status",
    gridEventTransactionListStatusWithdrawn: "Withdrawn",
    gridEventTransactionListStatusPending: "Pending",
    gridEventTransactionListStatusRejected: "Rejected",
    gridEventTransactionListStatusCancelled: "Cancelled",

    gridEventTransactionListActions: "Actions",
    gridEventTransactionListMoveToInProgressTransaction: "Move to In Progress",
    gridEventTransactionListInProgress: "Transaction In Progress",
    gridEventTransactionListApproveTransaction: "Approve Transaction",
    gridEventTransactionListDeclineTransaction: "Decline Transaction",
    gridEventTransactionListDownloadTransactionReceiptPdf:
      "Download Withdrawal Document Pdf",
    gridEventTransactionListDownloadTransactionFeePdf: "Download Fee Pdf",
    gridEventTransactionListDownloadTransactionEarlyWithdrawalFeePdf:
      "Download Early Fee Pdf",
    gridEventTransactionListDownloadTransactionFastWithdrawalFeePdf:
      "Download Fast Fee Pdf",

    gridOrganizerRequestListRequestInfo: "Request Info",
    gridOrganizerRequestListRequestMessage: "Request Message",
    gridOrganizerRequestListRequestDate: "Request Date",
    gridOrganizerRequestListActions: "Actions",
    gridOrganizerRequestListApproveRequest: "Approve Request",
    gridOrganizerRequestListDeclineRequest: "Decline Request",

    approveTransaction: "Approve Transaction",
    declineTransaction: "Decline Transaction",
    adminNotePlaceholder: "Leave admin note",
    approveRequest: "Approve Request",
    declineRequest: "Decline Request",
    cancel: "Cancel",

    gridEventsCrossQRScanner: "Show QR settings",
    eventCrossQRScannerModalTitle: "Update Event Cross QR Scanner Settings",
    relatedEventLink: "Related event link",
    addRelatedScannerEvent: "Add one more",
    updateRelatedScannerEvent: "Update event QR Scanner settings",
    relatedEventLinkRequiredError: "Related event link is required",
    relatedEventsSuccessUpdated: "Related events success updated",

    usersRequiredError: "This field is required",
    usersFormatError:
      "Each line must be in the format: phone,name,surname[,count[,IDcode]]",
    usersColumnsCountError: "Line {n}: expected next phone,name,surname",
    usersPhoneRequiredError: "Line {n}: phone is required",
    usersPhoneInvalidError: "Line {n}: invalid phone number",
    usersNameRequiredError: "Line {n}: first name is required",
    usersSurnameRequiredError: "Line {n}: last name is required",
    usersCountInvalidError: "Line {n}: count must be a positive integer",
    usersIdCodeInvalidError: "Line {n}: ID code contains invalid characters",
    smsRequiredError: "SMS Text is required",
    smsTextMustContainTicketLinkError: "SMS text must include %LINK_TO_TICKET%",

    giftNoneOption: "None",
    gridEventsGiftTickets: "Gift tickets",
    ticketsSuccessGifted: "Ticket success gifted",
    eventGiftTicketsModalTitle: "Gift tickets",
    giftUsersHelper: "Line format: phone,name,surname,count,IDcode",
    giftUsers: "Users for gift",
    giftSmsTextHelper:
      "For sms text need required variable %LINK_TO_TICKET% and optional %EVENT_NAME%",
    giftSmsText: "Sms text",
    giftTicketHelper:
      'You can select from exist ticket or add name (ticket created auto for list of users), default name "כרטיס מתנה לאירוע"',
    giftTicketSelect: "Select ticket (optional)",
    giftTicketName: "Ticket name (optional)",
    giftTickets: "Gift tickets",

    organizerEventFeeMinError: "Events fee minimum percent is 0",
    organizerEventFeeMaxError: "Events fee maximum percent is 100",
    organizerEventFeeRequiredError: "Events fee percent is required",
    updateFeePercentError: "Get error when try to update organizer events fee",
    organizerSettingsEventFeePercentModalTitle: "Organizer Events Fee",
    organizerEventFee: "Events Fee",
    organizerUpdateEventFeeSettings: "Update Events Fee",

    organizerFilesModalTitle: "Organizer files",
    organizerFilesModalAddFile: "Upload new file",

    uploadNewOrganizerFileModalTitle: "Upload new organizer file",
    uploadNewOrganizerFileModalTitleDropOrClickFileHere:
      "Click or Drop file here",
    uploadNewOrganizerFileModalTitleDropFileHere: "Click or Drop file here",

    pdfFilePreview: "PDF File preview",

    // Admin Create Transaction Modal
    createTransactionModalTitle: "Create new transaction for organizer event",
    selectOrganizerEvent: "Select organizer event",
    eventNameSearchLabel: "Search by event name",
    selectTransactionType: "Select transaction type",
    transactionTypeService: "Service",
    transactionTypeSimple: "Transaction",
    selectOrganizerBillAccount: "Select organizer bill account",
    billAccountNameSearchLabel: "Search by bill account name",
    successTransactionCreateMessage: "Transaction successfully created",
    selectedEventName: "Selected event name:",
    totalEventAmount: "Total event amount",
    totalWithdrawnAmount: "Total withdrawn amount",
    availableForWithdrawalAmount: "Available for withdrawal amount",
    calculateData: "Calculate transaction data",
    totalTransactionAmount: "Total transaction amount",
    transactionAmount: "Transaction amount",
    transactionFeeAmount: "Transaction fee amount",
    fastWithdrawalFeeAmount: "Fast withdrawal fee amount",
    warningOverdraftAmount: "This transaction will cause an overdraft!",
    overdraftAfterTransaction: "Overdraft after transaction created",
    transactionAmountLabel: "Transaction Amount",
    transactionFeeAmountLabel: "Transaction Fee Amount",
    transactionAdminWithdrawalFeeAmountLabel: "Admin Withdrawal Fee Amount",
    amountRequiredError: "Amount is required",
    adminFeeRequiredError: "Admin withdrawal fee amount is required",
    numberMinError: "Value must be more than 0",
    transactionFastWithdrawalFeeAmountLabel: "Fast Withdrawal Fee Amount",
    transactionAdminNoteLabel: "Transaction Admin Note",
    overdraftConfirmation:
      "I understand that the transaction will be created in overdraft",
    transactionNameLabel: "Transaction Name",
    transactionNameRequiredError: "Transaction name is required",
    transactionNameMinError: "Transaction name is too short (min 3 characters)",
    formViewCreateButton: "Create Transaction",
    serviceFormViewCreateButton: "Create Service Transaction",
    gridEventTransactionListItemAdminWithdrawal: "Admin Withdrawal",
    gridEventTransactionListItemAdminFee: "Admin Withdrawal Fee",
    gridEventTransactionListItemOverdraft: "Overdraft 🚨",
  },
};
